<template>
	<div style="width:1200px; height:810px;" v-on:keyup.esc="close()">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">PO Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="po_date_from"/> ~ <CustomDatePicker v-model="po_date_to"/></span>
				<em class="lt_text">PO No</em>
				<span class="int_type_no_border mgr_10">
					<CodeSelect className="tbl_select" :codes="pos" :showDesc="false" :width="100" :codeWidth="100" :nameWidth="100" codeHeader="PO No" nameHeader="PO Date" v-model="po_dn" @set-code="setPO" />
				</span>

				<em class="lt_text">Item {{ headers.class }}</em>
				<span class="int_type_no_border mgr_5"> <ItemClassSelect v-model="itemClass" :showName="false" /> </span>

				<span class="int_type mm_int">
					<input type="text" v-model.trim="keyword" placeholder="Item Name" ref="spkeyword" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>

				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>
		<div class="view_inner">
			<div class="fixed-table-container" ref="div_wrapper_parent" style="height:670px;">
				<div class="table-wrapper" ref="div_wrapper">
					<table id="item_list" class="list_tbl">
						<thead>
							<tr>
								<th style="text-align:center;width:2%;">
									<div class="th-text"><input type="checkbox" @change="selectAll()" v-model="allSelected" /></div>
								</th>
								<th style="text-align:center;width:2%"></th>
								<th style="text-align:center;width:10%;">
									<div class="th-text">{{ headers.class }}</div>
								</th>
								<th style="text-align:center;">
									<div class="th-text">
										<a href="javascript:;" @click="sort('name')">Name{{ sortMark('name') }}</a>
									</div>
								</th>
								<th style="text-align:center;width:7%;" v-if="user.company_id != 'jc'"><div class="th-text">Color</div></th>
								<th style="text-align:center;width:7%;"><div class="th-text">Price</div></th>
								<!-- <th style="text-align:center;width:7%;"><div class="th-text">Quantity</div></th> -->
								<th style="text-align:center;width:7%;"><div class="th-text">Remain Qty</div></th>
								<th style="text-align:center;width:7%;"><div class="th-text">Input Qty</div></th>
								<th style="text-align:center;width:4%;" v-if="user.company_id == 'jc'"><div class="th-text">U/M</div></th>
								<th style="text-align:center;width:5%;" v-if="user.company_id == 'jc'"><div class="th-text">QTY/CTN</div></th>
								<th style="text-align:center;width:9%;"><div class="th-text">Amount</div></th>
								<th style="text-align:center;width:7%;"><div class="th-text">Shipped Qty</div></th>
								<th style="text-align:center;width:7%;">
									<div class="th-text">
										<a href="javascript:;" @click="sort('po_dn')">PO No{{ sortMark('po_dn') }}</a>
									</div>
								</th>
								<th style="text-align:center;width:7%;">
									<div class="th-text">
										<a href="javascript:;" @click="sort('po_date')">PO Date{{ sortMark('po_date') }}</a>
									</div>
								</th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="(item, index) in filtered_items" v-bind:key="item.po_item_no" :class="{ background_gray: already_selected_items.findIndex(el => el.po_item_no === item.po_item_no) > -1 }">
								<td class="al_center"><input type="checkbox" v-model="item.selected" /></td>
								<td @dblclick.stop="" class="al_center">
									<template v-if="index == 0 || (index > 0 && (item.class_code != filtered_items[index - 1].class_code || item.po_no != filtered_items[index - 1].po_no))">
										<input type="checkbox" v-model="item.class_selected" @change="selectClassAll(item)" />
									</template>
								</td>
								<td class="al_left">{{ item.class_code }}</td>
								<td class="al_left">{{ item.item_name }}</td>
								<td class="al_left" v-if="user.company_id != 'jc'">{{ item.color_code }}</td>
								<td class="al_right">{{ item.unit_price | toPOCurrency(profile.po_decimal_point) }}</td>
								<!-- <td class="al_right">{{ item.quantity | commaSeparated }}</td> -->
								<td class="al_right">{{ item.remaining_quantity | commaSeparated }}</td>
								<td class="al_right">
									<currency-input
										type="text"
										v-model.trim="item.input_quantity"
										:precision="0"
										class="r_int long_type al_right"
										@focus="focusInputQuantity(item)"
										ref="quantity"
										:valueRange="{ min: 0, max: item.remaining_quantity }"
										@keydown.down.prevent="keyDown('quantity', index)"
										@keydown.up.prevent="keyUp('quantity', index)"
									/>
								</td>
								<td v-if="user.company_id == 'jc'" class="al_center">{{ item.purchase_unit_code }}</td>
								<td v-if="user.company_id == 'jc'" class="al_right">{{ item.packing | commaSeparated }}</td>
								<td class="al_right">{{ item.amount | toPOCurrency(profile.po_decimal_point) }}</td>
								<td class="al_right">{{ item.shipped_quantity | commaSeparated }}</td>
								<!-- <td class="al_left">{{ item.po_dn }}</td> -->
								<td class="al_left">
									<a href="javascript:;" @click="selectPurchase(item)">{{ item.po_dn }}</a>
								</td>
								<td class="al_left">{{ item.po_date }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- <div>
					{{ selectedUserIds }}
				</div> -->
			</div>

			<br />

			<div class="view_bottom_bt">
				<span class="fl_l">
					<font class="mgr_10">Selected Qty: {{ selected_quantity }}</font>
					<div style="display: inline-block; width: 12px; height: 12px; background: #bdbdbd;"></div>
					<font class="mgr_10"> : P/O Items Already Exist in the Shipment.</font>
				</span>
				<a href="javascript:;" type="button" class="search_bt" @click="ok()">Select</a>
				<a href="javascript:;" id="save" type="button" class="gray_bt" @click="close()">Cancel</a>
			</div>
		</div>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import '@/assets/css/table_box.css';
//import { apiSelectPartnerList } from '@/api/partner/index.js';
import { apiSelectPurchaseItemList, apiSelectPurchaseList } from '@/api/purchase/purchase.js';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import ItemClassSelect from '@/components/common/ItemClassSelect';
import CodeSelect from '@/components/common/CodeSelect';
import { daysAgo, today } from '@/utils/date.js';

export default {
	data: function() {
		return {
			po_date_from: daysAgo(365),
			po_date_to: today(),
			itemClass: null,
			keyword: null,
			po_dn: null,

			allSelected: false,

			sort_key: null,
			sort_direction: 'ASC',

			items: [],

			pos: [],
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		profile: function() {
			return this.$session.get('profile');
		},
		filtered_items: function() {
			return this.items.filter(i => i.quantity != i.shipped_quantity);
		},
		headers: function() {
			return { class: this.$session.get('headerClass') };
		},
		selected_quantity() {
			return this.items.filter(i => i.selected).reduce((prev, curr) => prev + curr.input_quantity, 0);
		},
	},
	props: {
		initialVendorCode: String,
		initialSortKey: String,
		already_selected_items: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		CustomDatePicker,
		ItemClassSelect,
		CodeSelect,
	},
	methods: {
		keyDown(ref, index) {
			if (index < this.filtered_items.length - 1) {
				this.$refs[ref][index + 1].$el.select();
				if (this.$refs[ref][index + 1].$el.offsetParent.offsetTop + 2 * this.$refs[ref][index + 1].$el.offsetParent.scrollHeight > this.$refs.div_wrapper_parent.scrollHeight) {
					this.$refs.div_wrapper.scrollTop += this.$refs[ref][index + 1].$el.offsetParent.scrollHeight + 1;
				}
			}
		},
		keyUp(ref, index) {
			if (index > 0) {
				this.$refs[ref][index - 1].$el.select();
				this.$refs.div_wrapper.scrollTop = this.$refs[ref][index - 1].$el.offsetParent.offsetTop;
			}
		},
		focusInputQuantity(item) {
			event.target.select();
			item.selected = true;
		},
		setPO(code) {
			if (code) {
				//console.log(code);
				this.po_dn = code.code;
				this.search();
			}
			// if (code) this.salesteam_name = code.name + ' (' + code.description + ')';
			// else this.salesteam_name = '';

			// if (!this.salesteam_code) return;

			// this.selectMembers();
			// this.selectSalesTeamBackupUsers();
		},
		selectClassAll(item) {
			//console.log(item.class_code, item.class_selected);
			this.filtered_items
				.filter(i => i.class_code == item.class_code && i.po_no == item.po_no)
				.forEach(i => {
					i.selected = item.class_selected;
				});
		},
		selectPurchase(purchase) {
			let routeData = this.$router.resolve({ name: 'purchaseDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, po_no: purchase.po_no } });
			window.open(routeData.href, 'herp_purchase');
		},
		sortMark: function(sort_key) {
			if (this.sort_key == sort_key) return this.sort_direction == 'ASC' ? '▲' : '▼';
			else return null;
		},
		sort(sort_key) {
			if (this.sort_key == sort_key) {
				this.sort_direction = this.sort_direction == 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'ASC';
			}
			this.selectPurchaseItems();
			//console.log(sort_key);
		},
		selectAll() {
			var vm = this;
			this.filtered_items.forEach(function(item) {
				item.selected = vm.allSelected;
			});
		},
		reset() {
			this.po_date_from = daysAgo(365);
			this.po_date_to = today();
			this.keyword = null;
			this.po_dn = null;
		},
		search() {
			//this.selectInvoices();
			this.selectPurchaseItems();
		},
		// selectRow(user) {
		// 	if (this.selectedUserIds.includes(user.user_id)) {
		// 		const index = this.selectedUserIds.indexOf(user.user_id);
		// 		if (index > -1) {
		// 			this.selectedUserIds.splice(index, 1);
		// 		}
		// 	} else this.selectedUserIds.push(user.user_id);
		// },
		async selectPurchaseItems() {
			var param = {
				po_date_from: this.po_date_from,
				po_date_to: this.po_date_to,
				vendor_code: this.initialVendorCode,
				class_code: this.itemClass,
				keyword: this.keyword,
				po_dn: this.po_dn,

				valid_only: true,

				sort_key: this.sort_key,
				sort_direction: this.sort_direction,
			};
			//console.log(param);
			const { data } = await apiSelectPurchaseItemList(param);
			if (data && Array.isArray(data.purchaseItemList)) {
				data.purchaseItemList.forEach(el => {
					el.input_quantity = el.remaining_quantity; // input_quantity 초기화
					el.selected = false;
				});

				if (this.user.company_id == 'beautyplus') data.purchaseItemList = data.purchaseItemList.filter(i => i.remaining_quantity > 0);

				this.items = data.purchaseItemList;
			} else this.items = [];

			//console.log(this.items);
		},
		close() {
			this.$emit('close');
		},
		ok() {
			var selectedItems = this.items.filter(item => item.selected);
			selectedItems.forEach(i => {
				i.selected = false;
			});
			//console.log(selectedItems);
			this.$emit('set-items', selectedItems);
			this.close();
		},
		async init() {
			const { data } = await apiSelectPurchaseList({
				paging_yn: 'N',
				sort_key: 'po_date',
				sort_direction: 'ASC',

				//po_date_from: this.po_date_from,
				//po_date_to: this.po_date_to,
				vendor_code: this.initialVendorCode,
				closed_yn: 'N',
			});
			//console.log(data);
			//console.log(JSON.stringify(data.purchaseList.map(({ po_dn, po_date }) => ({ code: po_dn, name: po_date }))));
			this.pos = data.purchaseList.map(({ po_dn, po_date }) => ({ code: po_dn, name: po_date }));
		},
	},

	created() {
		if (this.initialSortKey) this.sort_key = this.initialSortKey;
		this.init();
		this.search();
	},
	mounted() {
		inputSelectOnClick();

		setTimeout(() => {
			this.$refs.spkeyword.focus();
		}, 10);
	},
};
</script>

<style scoped lang="scss">
.background_gray td {
	background: #bdbdbd !important;
}
</style>
